import * as React from "react";
import type { SVGProps } from "react";
const SvgCondFormula = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={48} height={48} viewBox="0 0 48 48" {...props}><defs><radialGradient id="shadow" cx={0} cy={0} r={1} gradientTransform="translate(24 39.4) scale(19.2 3.6)" gradientUnits="userSpaceOnUse"><stop offset={0} stopColor="#000" stopOpacity={1} /><stop offset={1} stopColor="#000" stopOpacity={0} /></radialGradient></defs><ellipse cx={24} cy={39.4} rx={19.2} ry={3.6} fill="url(#shadow)" opacity={0.2} /><text x={24} y={37.4} textAnchor="middle" style={{
    fontSize: 33,
    fontStyle: "normal",
    fontWeight: "normal",
    fill: "#000000",
    fontFamily: "Sans"
  }}>{"f"}<tspan fill="none">{"("}</tspan>{"x"}<tspan fill="none">{")"}</tspan></text><text x={24} y={35.4} textAnchor="middle" transform="translate(0.7 0)" style={{
    fontSize: 33,
    fontStyle: "normal",
    fontWeight: "normal",
    fill: "#000000",
    fontFamily: "Sans"
  }}><tspan fill="none">{"f"}</tspan>{"("}<tspan fill="none">{"x)"}</tspan></text><text x={24} y={35.4} textAnchor="middle" transform="translate(-0.7 0)" style={{
    fontSize: 33,
    fontStyle: "normal",
    fontWeight: "normal",
    fill: "#000000",
    fontFamily: "Sans"
  }}><tspan fill="none">{"f(x"}</tspan>{")"}</text></svg>;
export default SvgCondFormula;